import { Dayjs } from "dayjs";

export const calculateGroupBy = (startDate: Dayjs | null, endDate: Dayjs | null) => {
    if (!startDate || !endDate) return null;

    const diffInDays = endDate.diff(startDate, "day");

    if (diffInDays < 31) {
        return "day";
    }

    if (diffInDays < 365) {
        return "week";
    }

    if (diffInDays < 1825) {
        return "month";
    }

    return "year";
};
